export default {
  GET_ALL_DEFAULTICONS: 'getAllDefaulticons',
  SAVE_DEFAULTICON: 'saveDefaulticon',
  UPDATE_DEFAULTICON: 'updateDefaulticon',
  DELETE_DEFAULTICON: 'deleteDefaulticon',
  GET_DEFAULTICON: 'getDefaulticon',
}
